import ExternalLink from '@components/ExternalLink/ExternalLink';
import Spacer from '@components/Spacer/Spacer';
import * as styles from '@layouts/HomeLayout.module.scss';
import * as React from 'react';
export default {
  ExternalLink,
  Spacer,
  styles,
  React
};